function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicenceSourceDongle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#cfd8dc",
      strokeWidth: 0.2795597
    },
    d: "M52.886 62.116V45.051h15.877v17.065z",
    transform: "matrix(0 .50371 .50372 0 -2.99 -23.217)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#546e7a",
      strokeWidth: 0.26458332
    },
    d: "M58.989 60.22v-4.74h3.792v4.74zm0-8.533v-4.74h3.792v4.74z",
    transform: "matrix(0 .50371 .50372 0 -2.99 -23.217)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#7c939c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.15730532,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M68.763 40.354h4.931v26.458h-4.931z",
    transform: "matrix(0 .50371 .50372 0 -2.99 -23.217)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#e7e7e7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.55280513,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M73.694 40.354h60.896v26.458H73.694z",
    transform: "matrix(0 .50371 .50372 0 -2.99 -23.217)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#7c939c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.15730533,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M129.659 40.354h4.931v26.458h-4.931z",
    transform: "matrix(0 .50371 .50372 0 -2.99 -23.217)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa000"
    },
    d: "m30 41-4 4h-4l-4-4V21h12v8l-2 2 2 2v2l-2 2 2 2z",
    transform: "matrix(.3988 0 0 .47856 26.429 24.465)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa000"
    },
    d: "M38 7.8c-.5-1.8-2-3.1-3.7-3.6C31.899 3.7 28.2 3 24 3c-4.2 0-7.898.7-10.3 1.2C12 4.7 10.5 6 10 7.8c-.5 1.7-1 4.098-1 6.7 0 2.602.5 5 1 6.7.5 1.8 1.898 3.1 3.7 3.5 2.402.6 6.1 1.3 10.3 1.3 4.2 0 7.898-.7 10.3-1.2 1.802-.402 3.2-1.8 3.7-3.5.5-1.698 1-4.1 1-6.698 0-2.704-.5-5.102-1-6.801ZM29 13H19c-1.102 0-2-.898-2-2V9c0-.602 3.102-1 7-1s7 .398 7 1v2c0 1.102-.898 2-2 2z",
    transform: "matrix(.3988 0 0 .47856 26.429 24.465)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d68600"
    },
    d: "M23 26h2v19h-2z",
    transform: "matrix(.3988 0 0 .47856 26.429 24.465)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceSourceDongle);
export default __webpack_public_path__ + "static/media/licenceSourceDongle.8a23c5b0aa79df1673fff7c8b6ff706a.svg";
export { ForwardRef as ReactComponent };